if (!customElements.get('faq-element')) {
  class FAQElement extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.navs = this.querySelectorAll('.faq__nav');
      this.summaries = this.querySelectorAll('summary');
      this.groupHeadings = this.querySelectorAll('.faq-group__heading');

      const faqGroupIDS = Array.from(this.groupHeadings).map((ele) => ele.id);
      const faqGroupHeadings = Array.from(this.groupHeadings).map((ele) => ele.textContent);

      let links = '';
      faqGroupIDS.forEach((id, i) => links = links + `<li><a href="#${id}" class="faq-nav__item eyebrow">${faqGroupHeadings[i]}</a></li>`)
      this.navs.forEach(ele => ele.innerHTML = links);
      this.navs.forEach(ele => ele.classList.add('active'));

      this.groupHeadings.forEach((ele) => ele.addEventListener('click', this.handleHeadingClick));
      this.summaries.forEach((ele) => ele.addEventListener('click', this.handleSummaryClick));
    }

    disconnectedCallback() {
      this.groupHeadings.forEach((ele) => ele.removeEventListener('click', this.handleHeadingClick));
      this.summaries.forEach((ele) => ele.removeEventListener('click', this.handleSummaryClick));
    }

    handleHeadingClick(event) {
      window.location.hash = event.currentTarget.id;
    }

    handleSummaryClick(event) {
      event.preventDefault();
      const details = this.closest('details');

      if (details.hasAttribute('open')) {
        details.classList.remove('opening');

        details.addEventListener('transitionend', () => {
          details.removeAttribute('open');
        }, {once: true})
      } else {
        details.setAttribute('open', '');
        setTimeout(() => details.classList.add('opening'));
      }
    }
  }
  
  customElements.define('faq-element', FAQElement);
}
